// app routes
const client = "/client/:clientId";
const createCompany = `${client}/company`;
const company = "/company/:companyId";
const routes = {
  client: {
    root: client,
    createCompany,
  },
  company: {
    root: company,
    link: `${company}/link/:sourceType?/(upload)?`,
    consent: `${company}/consent/:platformKey`,
    success: `${company}/success/:sourceType/:platformKey`,
    overview: `${company}/overview`,
    revisit: `${company}/revisit/:sourceType?`,
    error: `${company}/error/:sourceType/:platformKey/(retry)?`,
    customIntro: `${company}/intro/:sourceType/(upload)?`,
  },
  notfound: "/not-found",
  error: "/error",
  completed: "/completed",
  customIntro: "/custom/intro/:clientId",
};

export default routes;
